module.exports = __webpack_public_path__ + "img/pc_news_top_img.c8ad9f1.webp";